<!-- <div class="main-wrapper scrollspy-action">
    <div class="error-404-wrapper">
        <div class="container"> -->

            <!-- <div class="errorouterdiv">
                <div class="errorouterimg">

                    <div class="col-md-12">
                        <div class="errorpadding ">
                            <div class="text-center">
                                <img src="assets/images/ero.png" width="120">
                                <h4 *ngFor="let err of errorMessageInfo" class="gbl-er-hedtxt">{{err}}</h4>
                            </div>
                            <ng-container *ngIf="!loginError">
                            <h4 class="mb-0">We're unable to fulfill your request. Rest assured we have been notified and are looking into the issue</h4>

                            <div class="row pad-20">
                                <div class="col-md-12">
                                    <div class="error-mg-hed">
                                        <span> Speak to travel expert now</span>
                                        <p>{{displayMessage}} or
                                            <a routerLink="/contactus" href="#">Contact Us</a>
                                        </p>
                                    </div>
                                    <div class="callfreenumber" *ngIf="phoneNumber">
                                        <span class="err-cal "><i class="fa fa-phone fa-flip-horizontal"
                                                aria-hidden="true"></i>{{phoneNumber}}</span>
                                        <span>It's free to call from anywhere</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        </div>
                    </div>
                    <div class="">
                        <a *ngIf="moduleType=='FT'" routerLink="/home/flight" href="#">Home</a>
                        <a *ngIf="moduleType=='HT'" routerLink="/home/hotel" href="#">Home</a>
                        <a *ngIf="moduleType=='CR'" routerLink="/home/car" href="#">Home</a>
                        <a *ngIf="moduleType=='login'" (click)="navigateToBack()">Go Back</a>
                        <a *ngIf="!moduleType" (click)="navigateToBack()">Go Back</a>
                    </div>
                </div>
            </div> -->
       
            
            <!-- <div class="container">
               
                
                <main>
                    <div class="row justify-content-center mb-15 ">

                        <span
                        class="err-msg ml-3 errorouterdiv mainmessage-error-message" 
                        style="color: red;"
                      >
                      <img src="assets/images/warning.png" width="20" />
                       
                       Regret to inform you, Your booking process is failed due to some technical issues
                      </span>                       
                </div>

                <div class="row d-block ml-0">
                   
                        <ng-container *ngIf=" exceptionInfoMessage && exceptionInfoMessage.displayMessage">
                            <div class="alert alert-warning alert-dismissible" role="alert">
        
                                <div class="alert-message d-flex">
        
                                    <div class="col-md-3">
                                        <img src="assets/images/b2c-maintain-err.png" alt="Flight Icon" class="flight-icon" />
                                
                                    </div>
                                    <div class="col-md-1 vl"></div>
                                    <div class="col-md-8 text-lg-left">
                                    <div class="pb-1" *ngFor="let msg of exceptionInfoMessage.displayMessage"> {{msg}}</div>
                                
                                
                    </div>
                                
                                </div>
        
        
                            </div>
                            <div class="hr"></div>
        
                          
                        </ng-container>
                </div>

                  <button routerLink="/">Return to Home</button>
                  <button routerLink="/contactus">Contact Support</button>
                </main>
                
            
              </div>
       
        </div>
    </div> -->



    <div class="container">
        <div class="error-container">
            
            <div class="error-icon">
                We’re Sorry! We Couldn’t Complete Your Request
            </div>
            <div class="error-message text-justify mb-4">
         
                <span class="error-icon pr-2" width="120">⚠️</span>
                <span class="m-1"> 
                We apologize for the inconvenience; an unexpected technical issue has interrupted your booking. Our team is on it, but please feel free to reach out to one of our customer support agents below to get the help you need right away. Thank you for being so understanding, we appreciate your patience and look forward to getting you on your way! </span>
              </div>
            <div class="error-image pt-15">
                <div>
                    <img src="assets/images/global_error.jpeg" >
                </div>
              <div class="error-msg-container">
               
                  <!-- <div class="contact-info">
                                 <div class="phone-section">
                          <p>
                              Contact a support specialist  <span class="phone-icon">📞</span> <span class="phone-number">+91 7039758756</span> .
                          </p>
                       
                      </div>
                  </div> -->
               
                  <div class="error-important-links ytb-v2-footer-menus-items mb-5">
                    <div class="heading-important">   Customer Support Contact Options: </div>
                    <ul>
                        <ng-container  *ngFor="let link of importantLinkDetails">
                        <li class="ml-4 p-1"><a [routerLink]="link.router" [target]="'_blank'"> - {{link?.label}}</a></li>

                        </ng-container>
                       
                      </ul>

                  </div>

                  <div class="error-actions justify-content-center">
                    <button class="error-button" onclick="location.href='/'">Return to Home</button>
                    <button class="error-button" routerLink="/contactus">Contact Support</button>
                  </div>


              </div>
            </div>
       
      </div>
 
     
    </div>
 